// utils/animations.ts
import gsap from "gsap";

export const applyHoverAnimation = (
  selector: string,
  floatingTweenRef?: React.MutableRefObject<gsap.core.Tween | null>
) => {
  const el = document.querySelector(selector);
  if (!el) return;

  const hoverTl = gsap.timeline({ paused: true });

  hoverTl.to(el, {
    scale: 1.025,
    filter:
      "drop-shadow(0 0 2px rgba(0, 153, 255, 0.6)) drop-shadow(0 0 3px rgba(0, 153, 255, 0.4))",
    duration: 0.5,
    ease: "power3.out",
    transformOrigin: "center center",
  });

  el.addEventListener("mouseenter", () => {
    floatingTweenRef?.current?.pause();
    hoverTl.play();
  });

  el.addEventListener("mouseleave", () => {
    hoverTl.reverse();
    hoverTl.eventCallback("onReverseComplete", () => {
      floatingTweenRef?.current?.resume();
    });
  });
};
